import { render } from "./profile-gray.vue?vue&type=template&id=df8f1ada&ts=true"
import script from "./profile-gray.vue?vue&type=script&lang=ts"
export * from "./profile-gray.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__